import { hrRoutes, api } from "../../..";
import { ApiConfig } from "../../../ApiConfig";
const baseURL = ApiConfig.baseApi;
// ----------------------------------------------------------------
// Define attendance services
// ----------------------------------------------------------------

const services = {

  // ----------------------------------------------------------------
  // checkin a employee
  // ----------------------------------------------------------------

  checkin: (date, time, endDate, id, timeZone, includeNonScheduledDays) => {
    const token = localStorage.getItem("accessToken");
    const empId = localStorage.getItem("employeeId");
    const company = localStorage.getItem("id");
    const role = localStorage.getItem("role");
    const url = baseURL + hrRoutes.attendance.checkin + empId;
    const adminUrl = baseURL + hrRoutes.attendance.checkin + company;
    const params = {
      date: date,
      endDate: endDate,
      time: time,
      employeeId: id || empId,
      timezone: timeZone,
      company: company,
      includeNonScheduledDays: includeNonScheduledDays,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(role === "Admin" ? adminUrl : url, params, headers);
  },

  // ----------------------------------------------------------------
  // checkin a employee
  // ----------------------------------------------------------------

  checkout: (date, time, endDate, id, timeZone, includeNonScheduledDays) => {
    const token = localStorage.getItem("accessToken");
    const employee = localStorage.getItem("employeeId");
    const EmployeeId = id ? id : employee;
    const url = baseURL + hrRoutes.attendance.checkout + EmployeeId;
    const params = {
      date: date,
      endDate: endDate,
      time: time,
      timezone: timeZone,
      includeNonScheduledDays: includeNonScheduledDays,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.put(url, params, headers);
  },

  // ----------------------------------------------------------------
  // Check Holidays
  // ----------------------------------------------------------------

  checkHoliday: (start, end, email, from) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.attendance.checkHoliday;
    const params = {
      date: new Date(start),
      end: new Date(end),
      email: email,
      checkingFor: from,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },

  // ----------------------------------------------------------------
  // Group check-in / check-out
  // ----------------------------------------------------------------

  groupEmployees: (department, search, all) => {
    const token = localStorage.getItem("accessToken");
    const query = new URLSearchParams();
    if (department) query.append("department", department);
    if (search) query.append("search", search);
    if (all) query.append("all", "1");
    const qs = query.toString();
    const url = baseURL + hrRoutes.attendance.groupEmployees + (qs ? `?${qs}` : "");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.get(url, {}, headers);
  },

  groupCheckin: (payload) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.attendance.groupCheckin;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, payload, headers);
  },

  groupCheckout: (payload) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.attendance.groupCheckout;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.put(url, payload, headers);
  },

};

// Export the services
export default services;
